import React from 'react'
import cx from 'classnames'

export const RecaptchaTerms = (props) => (
  <span className={cx("recaptcha_terms", "small", props.className)}>
    This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </span>
)
